
export default function() {
  /**
   * All the conditions to display the information for printing the ticket
   * The information are displayed by the php on the attribute of the
   * element .ticket_item
   */
  if ($('.ticket').length) {
    let jumps = {
      pid1: {
        img: 'tandem_thumb.jpg',
        title: 'Baptême de chute libre',
        subtitle: 'Saut en tandem'
      },
      pid2: {
        img: 'pac_thumb.jpg',
        title: 'Saut',
        subtitle: 'Saut en progression accompagnée en chute - débutant'
      },
      pid3: {
        img: 'pac_thumb.jpg',
        title: 'PAC 6 sauts + 1 (vétéran & sénior)',
        subtitle: 'Saut en progression accompagnée en chute - débutant'
      },
      pid4: {
        img: 'pac_thumb.jpg',
        title: 'PAC 6 sauts + 1 (cadet & junior)',
        subtitle: 'Saut en progression accompagnée en chute - débutant'
      },
      pid5: {
        img: 'pac_thumb.jpg',
        title: 'PAC 6 sauts + 9 jusqu\'au Brevet A (cadet & junior)',
        subtitle: 'Saut en progression accompagnée en chute - débutant'
      },
      pid6: {
        img: 'pac_thumb.jpg',
        title: 'PAC 6 sauts + 9 jusqu\'au Brevet A (vétéran & sénior)',
        subtitle: 'Saut en progression accompagnée en chute - débutant'
      },
      pid7: {
        img: 'oa_thumb.jpg',
        title: '1 saut',
        subtitle: 'Saut en ouverture automatique - débutant'
      },
      pid8: {
        img: 'oa_thumb.jpg',
        title: '5 sauts (vétéran & sénior)',
        subtitle: 'Saut en ouverture automatique - débutant'
      },
      pid9: {
        img: 'oa_thumb.jpg',
        title: '5 sauts (cadet & junior)',
        subtitle: 'Saut en ouverture automatique - débutant'
      }
    };

    let options = {
        oid1: {
            title: 'Option : Suivi photo'
        },
        oid2: {
            title: 'Aucun suivi'
        }
    };

    let idProduit = 'pid' + $('.ticket_item').attr('data-pid');
    let oidProduit = 'oid' + $('.ticket_item').attr('data-oid');
    let keyOption = (oidProduit <= 4 && oidProduit > 0) ? oidProduit : false;

    if (keyOption) {
      $('.ticket_item').html(
        '<div class="ticket_item_img ticket_item_img--tandem">'+
        '<img src="/images/'+jumps[idProduit].img+'" class="img-responsive" alt="Premier saut en parachute">'+
        '</div>'+
        '<div class="ticket_item_desc">'+
        '<p class="title">'+jumps[idProduit].title+'</p>'+
        '<p class="subtitle">'+jumps[idProduit].subtitle+'</p>'+
        '<p class="option">'+options[keyOption].title+'</p>'+
        '</div>'
      );
    } else {
      $('.ticket_item').html(
        '<div class="ticket_item_img ticket_item_img--tandem">'+
        '<img src="/images/'+jumps[idProduit].img+'" class="img-responsive" alt="Premier saut en parachute">'+
        '</div>'+
        '<div class="ticket_item_desc">'+
        '<p class="title">'+jumps[idProduit].title+'</p>'+
        '<p class="subtitle">'+jumps[idProduit].subtitle+'</p>'+
        '</div>'
      );
    }

    window.print();
  }
}
